import {
  CalendarClock,
  ChevronDown,
  CircleCheck,
  Cog,
  Navigation,
  Search,
  SlidersHorizontal,
  TriangleAlert,
  UserX,
  WifiOff,
  Wrench,
} from 'lucide-react';

export const VEHICLE_FILTER_ICONS = {
  active: Navigation,
  available: CircleCheck,
  inMaintenance: Wrench,
  maintenanceStatus: Cog,
  noDriver: UserX,
  withAlerts: TriangleAlert,
  trackingAbsent: WifiOff,
  contractExpiring: CalendarClock,
};

export const FILTER_UI_ICONS = {
  search: Search,
  chevronDown: ChevronDown,
  sliders: SlidersHorizontal,
};
